import { render, staticRenderFns } from "./ad-header.vue?vue&type=template&id=6fae6e6c&scoped=true&"
import script from "./ad-header.vue?vue&type=script&lang=js&"
export * from "./ad-header.vue?vue&type=script&lang=js&"
import style0 from "./ad-header.vue?vue&type=style&index=0&id=6fae6e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae6e6c",
  null
  
)

export default component.exports